import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { TableModuleProps } from "../PermissionProps";
import { snakeCaseToNormalText } from "../utils";
import { TabelRowData } from "./TabelRowData";

const TableModuleAccess = (props: TableModuleProps) => {
  const { subModule, defaultValues, rowHeader,onUserUpdate } = props;
  const header = [" ", ...rowHeader];
  const module: string[] =
    subModule && Object.keys(subModule).length > 0
      ? Object.keys(subModule)
      : [];
  return (
    <TableContainer>
      {defaultValues && (
        <Table sx={{ minWidth: 650, maxWidth: 500 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              {header?.map((head: string) => (
                <TableCell key={head} align="left">
                  {snakeCaseToNormalText(head)}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {module?.map((data: string) => {
              return (
                <TableRow key={`${module}_${data}`}>
                  <TabelRowData
                    modulePermission={subModule[data]}
                    moduleName={data}
                    onChange={onUserUpdate}
                    initialData={defaultValues[data]}
                    rowHeader={rowHeader}
                  />
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      )}
    </TableContainer>
  );
};
export default TableModuleAccess;
